import React, { Component } from 'react';

import { Link } from 'react-router-dom';
import { T } from '../../../stores/textStore';
import membershipStore from '../../../stores/membershipStore';
import { loadMemberships } from '../../../actions/membershipActions';


export default class extends Component {
	isCancellable() {
        const { userSubscription } = this.props;
        if (userSubscription.subscription.membership.slug !== 'free') {
            if (/*userSubscription.status === 'current' &&*/ !userSubscription.end_date) {
                return true;
            }
        }
		return false;
    } 

    renderOptions() {
        const { userSubscription } = this.props;
        return (
            <span>
                {(userSubscription.subscription.membership.slug !== 'free') &&
                <Link 
                        to={'/change-cc'} 
                        className="btn btn-secondary mb-3"
                >
                    {T('Change Payment Preferences')}
                </Link>                
                }                								
                {this.isCancellable() && 
                    /*<Link 
                            to={`${this.props.userSubscription.id}/cancel`} 
                            className="btn btn-secondary mb-3"
                    >
                        {T('Cancel Membership Plan')}
                    </Link>*/
                    <a href="/memberships/cancel/" className="btn btn-secondary mb-3">
                        {T('Cancel Membership Plan')}
                    </a>                
                } 
            </span>
        );    
    }

    renderPrice() {
        const PAYMENT_FREQUENCY_ADJECTIVE_DISPLAY = {
            'monthly': 'monthly',
            'annual': 'annually',
        }        
        const { userSubscription } = this.props;	
        const { membership } = userSubscription.subscription;
        const { payment_frequency } = userSubscription.subscription;     
        const { promotion } = userSubscription;        
        let price = null;
        if (payment_frequency === 'annual') {
            //price = membership.annual_price/12;
            price = membershipStore.getAnnualPrice(membership);
        } else if (payment_frequency === 'monthly') {
            //price = membership.monthly_price;
            price = membershipStore.getMonthlyPrice(membership);
        }
        if (membership.slug === 'free') {
            return <h5>{membershipStore.defactoCurrency.symbol}0 {T('per month')}</h5>
        }
        return (
            <span>                           
                <h5>
                    {!promotion &&
                        <span>{price.display}<br /></span>
                    }
                    {promotion && 
                        <span>
                            <small>{T('Regular Price:')}</small>
                            <br />
                            <span className="text-muted">{price.display}</span>
                            <br />
                            {T('Promotion Price')}:
                            {/*promotion.initial ?
                                <small>
                                    {T('Promotion Price')}:
                                </small>
                                :
                                <small>
                                    {T('Promotion Price')} ({promotion.discount_percent}% {T('off')}):
                                </small>                                
                            */}
                            <br />
                            {promotion.initial ?
                                <span className="text-success font-weight-bold">
                                    {membershipStore.defactoCurrency.code} {membershipStore.defactoCurrency.symbol}{userSubscription.promotion.initial}
                                    <br />
                                    <small className="text-dark">
                                        {T('one-time for')} {promotion.discount_duration} {promotion.duration_units_label}
                                    </small>
                                </span>
                                :
                                <span className="text-success font-weight-bold">
                                    {membershipStore.getDefactoPriceDisplay(userSubscription)}
                                </span>     
                            }                           
                            <br />
                        </span>
                    }
                    {(!promotion || !promotion.initial) &&
                    <small>
                        {T('per month billed')}&nbsp;
                        {T(PAYMENT_FREQUENCY_ADJECTIVE_DISPLAY[payment_frequency])}
                        {(membership.slug !== 'free' && (!userSubscription.end_date || userSubscription.end_date < userSubscription.next_payment_date)) &&
                            <span><br />{T('Next payment:')} {userSubscription.next_payment_date}</span>
                        }                        
                    </small>
                    }
                </h5>
            </span>
        );
    }

	render() {
        const { userSubscription } = this.props;	
        const { membership } = userSubscription.subscription;		
		return (			
			<div className="card text-center mb-5">
                {userSubscription.end_date && 
                    <div className="card-header alert-warning" role="alert">
                        {T('This plan will end on')} {userSubscription.end_date}
                    </div>
                }        
                {userSubscription.status === 'pending' && 
                    <div className="card-header alert-success" role="alert">
                        {T('This plan will start on')} {userSubscription.start_date}
                    </div>
                }                               
                <div className="card-header text-white tkc-bg-gold-dark">                                     
                    {userSubscription.status === 'current' && 
                        <span>{T('Your Current Plan')}</span>
                    }
                    {userSubscription.status === 'pending' && 
                        <span>{T('Your Pending Plan')}</span>
                    }                    
                </div>                
				<div className="card-header bg-white">
					<h6 className="text-uppercase">{membership.name}</h6>
				</div>
				<div className="card-body">	                               				
					{this.renderPrice()}
                    {this.renderOptions()}                                         
                    {membership.features_as_list.map(feature =>
                        <p className="text-left" key={feature}>
                            <span className="ic-check tkc-text-red"></span>
                            {feature}
                        </p>
                    )}  
                    {membership.disclaimers_as_list.map(disclaimer =>
                        <p className="text-left small" key={disclaimer}>                        
                            {disclaimer}
                        </p>
                    )}                                                					
				</div>
			</div>
		);		
	}
}




// WEBPACK FOOTER //
// ./src/views/membership/components/UserSubscriptionListing.js